import { Container, Grid, Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";

const DARK_BLUE = "#1A2F6B";
const TEAL = "#00838F";

const useStyles = makeStyles((theme) => ({
  mainTitle: {
    fontFamily: "Akzidenz-Grotesk BQ, serif",
    textTransform: "uppercase",
    color: DARK_BLUE,
    textAlign: "center",
    marginTop: theme.spacing(4),
  },
  subtitle: {
    fontFamily: "Akzidenz-Grotesk BQ, serif",
    color: TEAL,
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },
  bodyText: {
    color: theme.palette.secondary.main,
    lineHeight: 1.8,
    marginBottom: theme.spacing(2),
  },
  boldText: {
    fontWeight: "bold",
  },
  finalStatement: {
    fontWeight: "bold",
    color: DARK_BLUE,
    lineHeight: 1.6,
    marginBottom: theme.spacing(2),
  },
}));

export default function GiftCardsHeader() {
  const classes = useStyles();
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("xs"));
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Container>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item xs={12}>
          <Typography
            variant={xs ? "h6" : sm ? "h5" : "h4"}
            className={classes.mainTitle}
          >
            ENTERPRISE-GRADE GIFT INTELLIGENCE:
          </Typography>
          <Typography
            variant={xs ? "h6" : sm ? "h5" : "h4"}
            className={classes.subtitle}
          >
            Turn Your Ledger into a Growth Engine.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant={xs ? "body2" : "body1"}
            className={classes.bodyText}
          >
            Our <span className={classes.boldText}>cloud-native,</span> browser-based
            platform allows retailers to launch, manage, and scale their entire gift
            ecosystem - from custom physical cards to digital-first
            experiences - with{" "}
            <span className={classes.boldText}>zero complex integration</span>.
          </Typography>
          <Typography
            variant={xs ? "body2" : "body1"}
            className={classes.bodyText}
          >
            We turn your gift ledger into{" "}
            <span className={classes.boldText}>actionable profit</span> by auditing
            every activation and redemption in real-time, unlocking the branch-level
            trends and{" "}
            <span className={classes.boldText}>unclaimed revenue</span> needed for
            forensic financial accuracy and smarter marketing spend.
          </Typography>
          <Typography
            variant={xs ? "body2" : "body1"}
            className={classes.finalStatement}
          >
            Finally, a streamlined platform that gives Finance total oversight, IT
            zero technical debt, and Marketing the data to scale.
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
